import { render, staticRenderFns } from "./copyMine.vue?vue&type=template&id=8548a72e&scoped=true"
import script from "./copyMine.vue?vue&type=script&lang=js"
export * from "./copyMine.vue?vue&type=script&lang=js"
import style0 from "./copyMine.vue?vue&type=style&index=0&id=8548a72e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8548a72e",
  null
  
)

export default component.exports